// extracted by mini-css-extract-plugin
export default {"container":"MoveProducts_container__3BRUb","input":"MoveProducts_input__FkfTD","select":"MoveProducts_select__3KiF-","button":"MoveProducts_button__Jo99X"};